import React from "react";
import { useTranslation } from "react-i18next";
import moment from "moment";
import currencies from "../../../services/currencies.json";
import Select from "react-select";
import { compactSelect } from "../../../design/selectStyle";
import DatePicker from "react-datepicker";


const PaymentOrderInfo = ({ paymentOrder, setPaymentOrder, validationErrors, handleChange, disabled,isEdit }) => {
  const { t } = useTranslation("translations");
  const handleDescriptionChange=(value)=>{
    setPaymentOrder(paymentOrder=>{
      const paymentOrderRecords = paymentOrder.paymentOrderRecords.map(record=>({
        ...record,
        description:value
      }))
      return {...paymentOrder,description:value,paymentOrderRecords}
    })
  }

  return (
    <div>
      <div className="d-flex justify-content-between header border-bottom">
        <div>
          <label className="field-label ml-2">
            {t("paymentOrder.paymentOrderInfo")}
          </label>
        </div>
      </div>
      <div className="row mx-1 mx-md-auto">

        <div className="col-12 col-md-4 py-0 px-2">
          <label className="field-label" htmlFor="creditorAccountReferenceType">
            {t("paymentOrder.refType")}
          </label>
          <input
            type="text"
            name="creditorAccountReferenceType"
            id="creditorAccountReferenceType"
            className="form-control form-control-sm"
            value={paymentOrder?.sellerBankAccountTransactional?.creditorAccountReferenceType ?? ""}
            onChange={handleChange}
            disabled
          />
        </div>

        <div className="col-12 col-md-4 py-0 px-2">
          <label className="field-label" htmlFor="endToEndId">
            {t("openBanking.paymentOrderId")}
          </label>
          <input
            type="text"
            name="endToEndId"
            className="form-control form-control-sm"
            value={paymentOrder?.endToEndId ?? ""}
            onChange={handleChange}
            disabled
          />
        </div>

        <div className="col-12 col-md-4 py-0 px-2 mt-1">
          <label className="field-label" htmlFor="referenceNo">
            {t("paymentOrder.refNo")}
          </label>
          <input
            type="text"
            name="referenceNo"
            id="referenceNo"
            className="form-control form-control-sm"
            value={paymentOrder?.referenceNo ?? ""}
            onChange={handleChange}
            disabled
          />
        </div>
         <div className="col-12 col-md-4 py-0 px-2 pt-2">
          <label className="field-label" htmlFor="issueDateTime">{t("paymentOrder.paymentOrderDate")}</label>
          <DatePicker
            selected={paymentOrder?.issueDateTime}
            onChange={(date)=>handleChange(null,"issueDateTime",date)}
            dateFormat="dd/MM/yyyy"
            disabled={disabled}
            customInput={
              <input
                className={`form-control form-control-sm ${validationErrors?.issueDateTime ? "is-invalid" : ""
                  }`}
              />
            }
          />
        </div>

        <div className="col-12 col-md-4 py-0 px-2">
          <label className="field-label mt-1" htmlFor="currency">{t("openBanking.currency")}</label>
          <Select
            options={currencies}
            styles={{
              ...compactSelect,
              menuPortal: (base) => ({ ...base, zIndex: 10001 }),
            }}
            value={currencies.find(
              (currency) => currency.value === paymentOrder.currency
            )}
            isSearchable={true}
            onChange={(opt) =>handleChange(null,"currency",opt.value)}
            menuPortalTarget={document.body}
            menuPosition="fixed"
            isDisabled={disabled}
          />
      </div>
        <div className="col-8 py-0 px-2">
          <label className="field-label" htmlFor="description">
            {t("paymentOrder.description")}
          </label>
          <textarea
            rows={2}
            type="text"
            name="description"
            className="form-control form-control-sm"
            value={paymentOrder?.description ?? ""}
            onChange={(e)=>handleDescriptionChange(e.target.value)}
            disabled={disabled}
          />
        </div>
      </div>
    </div>
  );
};

export default PaymentOrderInfo;
